import React, { useState } from 'react';
import Image from 'next/image';
import Button from '../Button/Button';
import CloseButton from '../Elements/CloseButton';
import Hr from '../Elements/Hr';
import { useRouter } from 'next/navigation';
import { ROUTES } from '@/config/routes';
import { T } from '@tolgee/react';
import LimitModal from '@/components/Modal/LimitModal';
export interface TransformedExpert {
  imageUrl: string;
  name: string;
  title: string;
  description: string;
  tags: string[];
  experience: string;
  expertId: string;
  id: string;
  external_id: string;
}
interface ExpertDetailsModalProps {
  expert: TransformedExpert;
  isOpen: boolean;
  onClose: () => void;
}
const ExpertDetailsModal: React.FC<ExpertDetailsModalProps> = ({
  expert,
  isOpen,
  onClose
}) => {
  const router = useRouter();
  const [usageLimitExceeded, setUsageLimitExceeded] = useState<boolean>(false);
  if (!isOpen) return null;
  const handleNavigateToExpert = () => {
    if (expert) {
      const fetchAvailabilities = async () => {
        try {
          router.push(ROUTES.BOOK_EXPERT(expert.expertId));
        } catch (error) {
          if ((error as any)?.status === 402) {
            setUsageLimitExceeded(true);
          }
          console.error('Error fetching availabilities:', error);
        }
      };
      fetchAvailabilities();
    }
  };
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 " data-sentry-component="ExpertDetailsModal" data-sentry-source-file="ExpertDetailsModal.tsx">
      {!usageLimitExceeded ? <div className="bg-gray-100 rounded-lg shadow-lg max-w-[750px] w-full p-6 relative max-h-screen overflow-scroll">
          <CloseButton onClose={onClose} className="absolute top-2 right-2" fill="black" />

          <div className="flex flex-col md:flex-row md:gap-6 mb-4">
            <div className="h-40 w-40 relative mb-4 md:mb-0">
              <Image src={expert.imageUrl} alt={expert.name} fill className="rounded-full object-cover" />
            </div>
            <div className="flex flex-col justify-center">
              <p className="text-sm text-primary uppercase mb-2 tracking-wider text-center md:text-left">
                {expert.title}
              </p>
              <h2 className="text-4xl mb-2 text-center md:text-left">{expert.name}</h2>
              <div className="flex flex-wrap justify-center md:justify-start gap-2">
                {expert.tags.map((tag, index) => <span key={index} className="bg-white py-2.5 px-4 rounded-full text-base">
                    {tag}
                  </span>)}
              </div>
            </div>
          </div>
          <Hr borderColour="#E1E1E1" />
          <div className="relative">
            <div className="mb-10 overflow-y-auto max-h-72">
              <p className="text-base font-poppins mb-4">{expert.experience}</p>
              <h3 className="text-base font-semibold mb-2">
                <T>expert_details.about.title.label</T>
              </h3>
              <p className="text-base font-poppins leading-[1.4] pb-5">{expert.description}</p>
              <span className="absolute bottom-0 left-0 right-0 h-10 bg-gradient-to-t from-gray-100 to-transparent pointer-events-none block"></span>
            </div>
          </div>
          <div className="mt-6">
            <Button onClick={handleNavigateToExpert}>
              <T>expert_details.button.book_now.label</T>
            </Button>
          </div>
        </div> : <LimitModal isOpen={isOpen} onClose={onClose} />}
    </div>;
};
export default ExpertDetailsModal;